module.exports = __webpack_public_path__ + "static/karolinaczarnota-a96385677550168fb9cd94b2db5784cb.jpg";